import { createSelector } from 'reselect';
import { AppState } from 'pages/app/state';
import { OperationItem } from 'types/operation-item';
import { RowProps } from './props';

const getOperationItem = (state: AppState, props: RowProps): OperationItem => {
  const operationItem = state.operationGrid.items.find(oi => oi.clientTransactionId === props.clientTransactionId);
  return operationItem
    ? operationItem
    : {} as OperationItem;
};

export const getOperationItemSelector = createSelector(
  getOperationItem,
  (operationItem) => {
    return operationItem;
  }
);


// WEBPACK FOOTER //
// ./src/components/operation-grid/rows/row/selectors.ts